import assetPath from '/app/xinglets/career-hub/bewerbung-topic-page/src/bewerbung-topic-page/articles-box-section/assets/first-article-image.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')